import React, { useState, useEffect } from "react";
import axios from "axios";
import FadeIn from "react-fade-in";
import Lottie from "react-lottie";
import ReactLoading from "react-loading";
import * as doneData from "./doneLoading.json";
import "./loading.css";
import "bootstrap/dist/css/bootstrap.css";
import { Redirect } from "react-router-dom";
import api from "./api-endpoints.json";

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: doneData.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const Loading = (props) => {
  const [state, setState] = useState({
    invalidCode: false,
    alreadyResponded: false,
    errorFlag: false,
  });
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let inviteCode = undefined;
  if (params) {
    inviteCode = params.get("inviteCode");
  }
  useEffect(() => {
    setTimeout(() => {
      if (inviteCode) {
        const getData = async () => {
          const inviteData = await axios({
            method: "post",
            url: api.ValidateInvite,
            data: {
              inviteCode: inviteCode,
            },
            config: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Credentials": true,
            },
          });
          const slotTimeData = await axios({
            method: "get",
            url: api.CandidatePortalConfigTime,
          });
          const headerFooterData = await axios({
            method: "get",
            url: api.CandidatePortalConfigText,
          });
          if (inviteData.data.verify === 1) {
            let tempState = state;
            tempState.invalidCode = true;
            setState(tempState);
            props.doneHandler();
          } else if (inviteData.data.verify === 2) {
            props.stateHandler({
              inviteCode: inviteData.data.candidateData.inviteCode,
              name: inviteData.data.candidateData.CandidateName,
              phoneNumber: inviteData.data.candidateData.PhoneNumber,
              linkSentTime: inviteData.data.candidateData.LinkSentTime,
              slotTime: slotTimeData.data,
              header: headerFooterData.data.header,
              footer: headerFooterData.data.footer,
            });
          } else if (inviteData.data.verify === 3) {
            let tempState = state;
            tempState.alreadyResponded = true;
            props.doneHandler();
            setState(tempState);
          } else {
            let tempState = state;
            tempState.errorFlag = true;
            props.doneHandler();
            setState(tempState);
          }
        };
        getData();
      }
    }, 1200);
  }, []);
  if (inviteCode && !props.done) {
    return (
      <div className="body-content">
        <img src={require("./logo.png")} alt="logo" />
        <FadeIn>
          <div className="d-flex justify-content-center align-items-center">
            <ReactLoading type={"spin"} color={"red"} />
          </div>
        </FadeIn>
      </div>
    );
  } else if (inviteCode && props.done) {
    if (state.invalidCode) {
      return (
        <div className="body-content">
          <img src={require("./logo.png")} alt="logo" />
          <FadeIn>
            <div className="d-flex justify-content-center align-items-center">
              <p>Invalid Code</p>
            </div>
          </FadeIn>
        </div>
      );
    } /*else if (state.alreadyResponded) {
      return (
        <div className="body-content">
          <img src={require("./logo.png")} alt="logo" />
          <FadeIn>
            <div className="d-flex justify-content-center align-items-center">
              <p>Already Responded</p>
            </div>
          </FadeIn>
        </div>
      );
    }*/ else if (state.errorFlag) {
      return (
        <div className="body-content">
          <img src={require("./logo.png")} alt="logo" />
          <FadeIn>
            <div className="d-flex justify-content-center align-items-center">
              <p>Error</p>
            </div>
          </FadeIn>
        </div>
      );
    } else {
      return (
        <div className="body-content">
          <img src={require("./logo.png")} alt="logo" />
          <FadeIn>
            <div className="d-flex justify-content-center align-items-center">
              <Lottie options={defaultOptions} height={120} width={120} />
              <Redirect to="/response"></Redirect>
            </div>
          </FadeIn>
        </div>
      );
    }
  } else {
    return (
      <div className="body-content">
        <img src={require("./logo.png")} alt="logo" />
        <FadeIn>
          <div className="d-flex justify-content-center align-items-center">
            <p>Invalid URL</p>
          </div>
        </FadeIn>
      </div>
    );
  }
};

export default Loading;
